module.exports = __webpack_public_path__ + "img/新能源.761187a0.png";